var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"alert alert-info"},[_c('strong',[_vm._v("Heads up!")]),_vm._v(" Right now you're in readonly mode. You can look, but can't touch. If you want to be able to use the tool yourself, "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" to get started with your 14 day free trial.\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e07d2cb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utilities/readonly-alert.vue
// module id = PTG4
// module chunks = 0